import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { menuData } from '../../mocks/menuData';

export default function MenuPage() {
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-6xl md:text-7xl font-serif font-bold text-[#3D2817] mb-6">
            Our Menu
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light">
            Freshly prepared daily with locally sourced ingredients from trusted Yorkshire suppliers
          </p>
        </div>
      </section>

      {/* Featured Items Section */}
      <section className="py-16 px-6 bg-[#F5F3F0]">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <h2 className="text-4xl font-bold text-[#3D2817] mb-3">Our Menu Favourites</h2>
            <p className="text-gray-600 text-lg font-light">The most loved dishes by our regular customers</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Breakfast Card */}
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg">
              <div className="relative" style={{ height: '280px' }}>
                <img 
                  src="https://public.readdy.ai/ai/img_res/ed9276351cbbe4f0d3e896cfae9bff67.jpg" 
                  alt="Full English Breakfast" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-2xl font-bold text-[#3D2817] mb-2">Full English Breakfast</h3>
                <p className="text-3xl font-bold text-[#C17855] mb-4">£8.95</p>
                <button className="w-4/5 mx-auto block px-6 py-3 bg-[#3D2817] text-white rounded-full font-medium hover:bg-[#2D1F12] transition-colors whitespace-nowrap cursor-pointer">
                  Order Now
                </button>
                <p className="text-xs text-gray-500 mt-3">Available until 11:30am</p>
              </div>
            </div>
            
            {/* Coffee Card */}
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg">
              <div className="relative" style={{ height: '280px' }}>
                <img 
                  src="https://readdy.ai/api/search-image?query=Artisan%20coffee%20cup%20with%20latte%20art%20beautiful%20foam%20design%20on%20wooden%20table%20warm%20brown%20tones%20steam%20rising%20from%20fresh%20coffee%20simple%20clean%20background%20specialty%20coffee%20high%20quality%20beans%20cafe%20beverage&width=400&height=280&seq=menu-coffee-featured-007&orientation=landscape" 
                  alt="Artisan Coffee" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-2xl font-bold text-[#3D2817] mb-2">Artisan Coffee</h3>
                <p className="text-3xl font-bold text-[#C17855] mb-4">From £2.80</p>
                <button className="w-4/5 mx-auto block px-6 py-3 bg-white text-[#3D2817] border-2 border-[#3D2817] rounded-full font-medium hover:bg-[#3D2817] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                  See Coffee Menu
                </button>
                <p className="text-xs text-gray-500 mt-3">Locally roasted beans</p>
              </div>
            </div>
            
            {/* Cakes Card */}
            <div className="bg-white rounded-3xl overflow-hidden shadow-lg">
              <div className="relative" style={{ height: '280px' }}>
                <img 
                  src="https://readdy.ai/api/search-image?query=Homemade%20cake%20slice%20on%20white%20plate%20with%20fork%20moist%20sponge%20cake%20with%20cream%20filling%20simple%20clean%20background%20fresh%20baked%20dessert%20cafe%20pastry%20delicious%20sweet%20treat%20British%20bakery%20style&width=400&height=280&seq=menu-cake-featured-008&orientation=landscape" 
                  alt="Homemade Cakes" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-2xl font-bold text-[#3D2817] mb-2">Homemade Cakes</h3>
                <p className="text-3xl font-bold text-[#C17855] mb-4">£3.50</p>
                <button className="w-4/5 mx-auto block px-6 py-3 bg-white text-[#3D2817] border-2 border-[#3D2817] rounded-full font-medium hover:bg-[#3D2817] hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                  View Selection
                </button>
                <p className="text-xs text-gray-500 mt-3">Baked fresh daily</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Coffee Menu */}
      <section className="py-16 px-6 bg-[#FAF7F2]">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-cup-line text-[#C17855] text-4xl"></i>
            </div>
            <h2 className="text-4xl font-bold text-[#3D2817]">Coffee</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
            {menuData.coffee.map((item, index) => (
              <div key={index} className="flex justify-between items-start border-b border-gray-300 pb-4">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#3D2817] mb-1">{item.name}</h3>
                  {item.description && (
                    <p className="text-sm text-gray-600">{item.description}</p>
                  )}
                </div>
                <span className="text-lg font-bold text-[#C17855] ml-4 whitespace-nowrap">{item.price}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Breakfast Menu */}
      <section className="py-16 px-6 bg-[#F5F3F0]">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-restaurant-line text-[#C17855] text-4xl"></i>
            </div>
            <h2 className="text-4xl font-bold text-[#3D2817]">Breakfast</h2>
          </div>
          <p className="text-gray-600 mb-8 text-sm">Served Monday - Saturday 8:00am - 11:30am | Sunday 9:00am - 11:30am</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
            {menuData.breakfast.map((item, index) => (
              <div key={index} className="flex justify-between items-start border-b border-gray-300 pb-4">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#3D2817] mb-1">{item.name}</h3>
                  {item.description && (
                    <p className="text-sm text-gray-600">{item.description}</p>
                  )}
                </div>
                <span className="text-lg font-bold text-[#C17855] ml-4 whitespace-nowrap">{item.price}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Light Lunches */}
      <section className="py-16 px-6 bg-[#FAF7F2]">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-bowl-line text-[#C17855] text-4xl"></i>
            </div>
            <h2 className="text-4xl font-bold text-[#3D2817]">Light Lunches</h2>
          </div>
          <p className="text-gray-600 mb-8 text-sm">Served daily from 11:30am - 4:00pm</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
            {menuData.lunch.map((item, index) => (
              <div key={index} className="flex justify-between items-start border-b border-gray-300 pb-4">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#3D2817] mb-1">{item.name}</h3>
                  {item.description && (
                    <p className="text-sm text-gray-600">{item.description}</p>
                  )}
                </div>
                <span className="text-lg font-bold text-[#C17855] ml-4 whitespace-nowrap">{item.price}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cakes & Treats */}
      <section className="py-16 px-6 bg-[#F5F3F0]">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-cake-3-line text-[#C17855] text-4xl"></i>
            </div>
            <h2 className="text-4xl font-bold text-[#3D2817]">Cakes & Treats</h2>
          </div>
          <p className="text-gray-600 mb-8 text-sm">Baked fresh every morning</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
            {menuData.cakes.map((item, index) => (
              <div key={index} className="flex justify-between items-start border-b border-gray-300 pb-4">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#3D2817] mb-1">{item.name}</h3>
                  {item.description && (
                    <p className="text-sm text-gray-600">{item.description}</p>
                  )}
                </div>
                <span className="text-lg font-bold text-[#C17855] ml-4 whitespace-nowrap">{item.price}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}